<script lang="ts">
	import { fade } from 'svelte/transition';
	import type { Snippet } from 'svelte';

	let {
		visible = false,
		x = 0,
		y = 0,
		bindEl,
		text,
		snippet
	}: {
		visible?: boolean;
		x?: number;
		y?: number;
		bindEl?: (el: HTMLElement) => void;
		text?: string;
		snippet?: Snippet;
	} = $props();

	let el: HTMLElement | undefined = $state();

	$effect(() => {
		if (el) {
			bindEl?.(el);
		}
	});
</script>

{#if visible}
	<div
		transition:fade={{ duration: 100 }}
		class="tooltip"
		style="left: {x}px; top: {y}px; transform: translateX(-50%);"
		aria-live="polite"
		bind:this={el}
	>
		{#if snippet}
			{@render snippet()}
		{:else}
			{text}
		{/if}
	</div>
{/if}

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;
	.tooltip {
		position: fixed;
		background: var(--surface-1);
		color: var(--text-primary);
		border: 1px solid var(--border-subtle);
		padding: 0.375rem 0.5rem;
		border-radius: 0.5rem;
		font-size: 0.75rem;
		pointer-events: none;
		z-index: 1000;
		max-width: 24rem;
		overflow: hidden;
	}
</style>
